export default [{
  path: '/employee_kpp',
  name: 'employee_kpp',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/kpp/employeeKpp/index')
}]
